// "What it ran me" ledger slip: simple-interest difference between the rate
// you get and the rate on offer nearby. Pure client-side, no request.
import gsap from "gsap";

const MINE = { amount: 80000, months: 17, r1: 0.4, r2: 4.5 };

const format = (diff) => (diff < 0 ? "−$" : "$") + Math.round(Math.abs(diff)).toLocaleString("en-US");

export function initCalculator() {
  document.querySelectorAll("[data-calc]").forEach((box) => {
    const inputs = {};
    ["amount", "months", "r1", "r2"].forEach((key) => {
      inputs[key] = box.querySelector(`[data-k="${key}"]`);
    });

    const out = box.querySelector("[data-result]");
    const note = box.querySelector("[data-note]");
    const reset = box.querySelector("[data-reset]");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const shown = { value: 0 };

    const num = (key) => Number(inputs[key].value) || 0;

    const calc = (animate) => {
      const diff = (num("amount") * (num("r2") - num("r1")) / 100) * (num("months") / 12);

      if (animate && !reduceMotion) {
        gsap.to(shown, {
          value: diff,
          duration: 0.6,
          ease: "power2.out",
          overwrite: true,
          onUpdate: () => {
            out.textContent = format(shown.value);
          },
        });
      } else {
        shown.value = diff;
        out.textContent = format(diff);
      }

      const mine = Object.keys(MINE).every((key) => num(key) === MINE[key]);
      note.textContent = mine ? note.dataset.mine : note.dataset.yours;
    };

    Object.values(inputs).forEach((input) => input.addEventListener("input", () => calc(true)));

    if (reset) {
      reset.addEventListener("click", () => {
        Object.keys(MINE).forEach((key) => {
          inputs[key].value = MINE[key];
        });
        calc(true);
      });
    }

    calc(false);
  });
}
